<template>
  <bxp-form-framework
    sidebar-background="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2019/12/bountixp-enterprise-enquiry-sidebar.jpg"
    dark-background
  >
    <template v-slot:sidebar-primary-text>
      Scale your business with our <strong>Enterprise plan</strong>.
    </template>
    <template v-slot:sidebar-secondary-text>
      Powerful, flexible and customised to fit your needs today and support your growth tomorrow.
    </template>
    <template v-slot:main-content>
      <form-wizard />
    </template>
  </bxp-form-framework>
</template>

<script>
export default {
  name: "app",
  data() {
    return {

    }
  }
};
</script>

<style>
  /* Wizard overrides *************************/
  .tab-navigation {
    box-shadow: none !important;
  }
  
</style>
